<script>
	import { locale } from '$lib/translations';

	let socialLinks = $derived([
		{
			name: 'Instagram',
			href: 'https://instagram.com/sistrall',
			title: 'Visit my Instagram profile (opens in new tab)',
			icon: 'instagram'
		},
		{
			name: 'Bluesky',
			href: 'https://bsky.app/profile/sistrall.it',
			title: 'Connect with me on Bluesky (opens in new tab)',
			icon: 'bluesky'
		},
		{
			name: 'GitHub',
			href: 'https://github.com/sistrall/',
			title: 'Check out my GitHub projects (opens in new tab)',
			icon: 'github'
		},
		{
			name: 'Observable',
			href: 'https://observablehq.com/@sistrall',
			title: 'See my Observable notebooks (opens in new tab)',
			icon: 'observable'
		},
		{
			name: 'DatoCMS',
			href: 'https://www.datocms.com/',
			title: "The most complete, user-friendly and performant headless CMS, and I'm part of the crew! (opens in new tab)",
			icon: 'datocms'
		},
		{
			name: 'LinkedIn',
			href: 'https://www.linkedin.com/in/sistrall/',
			title: 'View my professional profile (opens in new tab)',
			icon: 'linkedin'
		},
		{
			name: 'Pinterest',
			href: 'https://it.pinterest.com/sistrall/',
			title: 'Visit my Pinterest boards (opens in new tab)',
			icon: 'pinterest'
		},
		{
			name: 'Komoot',
			href: 'https://www.komoot.com/it-it/user/1614186305327',
			title: 'Visit my Komoot profile (opens in new tab)',
			icon: 'komoot'
		},
		{
			name: 'Letterboxd',
			href: 'https://letterboxd.com/sistrall/',
			title: 'Visit my Letterboxd profile (opens in new tab)',
			icon: 'letterboxd'
		},
		{
			name: 'RSS',
			href: `/${$locale}/feed.xml`,
			title: 'Subscribe to my RSS feed (opens in new tab)',
			icon: 'rss'
		}
	]);
</script>

<ul class="grid grid-cols-2 gap-2 md:gap-4">
	{#each socialLinks as { name, href, title, icon }}
		<li>
			<a class="flex align-middle gap-2 font-sans text-bridal-heath-50 text-stroke-blue-500 items-center" target="_blank" {href} aria-label={name} {title}>
				<img height="32" width="32" src="https://cdn.simpleicons.org/{icon}" alt="{name} icon" />
				<span>{name}</span>
			</a>
		</li>
	{/each}
</ul>
